import { makeStyles } from 'transfix-ui/core'
import { getBrandColor } from 'transfix-ui'

export const useExtendedCarrierScorecardStyles = makeStyles(theme => ({
  root: {
    '&.big': {
      width: theme.spacing(36),
    },
    '&.wrapped': {
      padding: theme.spacing(2),
    },
    '&.blueTitle .title': {
      color: getBrandColor('skyBlue6').hex(),
    },
  },
  countMessage: {
    display: 'flex',
    alignItems: 'center',
    '& .icon': {
      marginRight: theme.spacing(1),
    },
  },
  shipmentsLabel: {
    marginBottom: theme.spacing(1),
    '& .label': {
      color: getBrandColor('coolGray6').hex(),
    },
    '& .icon': {
      display: 'inline-block',
      marginRight: theme.spacing(1),
    },
  },
  carrierState: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    textTransform: 'capitalize',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: getBrandColor('warning').hex(),
    '& h6': {
      color: getBrandColor('warning').hex(),
    },
    '&.activated, &.activated h6': {
      color: getBrandColor('skyBlue7').hex(),
    },
    '& > *': {
      marginRight: theme.spacing(1),
    },
  },
  rateTag: {
    textTransform: 'capitalize',
    border: '2px solid',
    borderColor: 'transparent',
    '&.dpl-tag-accent-green': {
      backgroundColor: getBrandColor('green1').hex(),
      borderColor: getBrandColor('green1').hex(),
      '& *': {
        color: getBrandColor('green3').hex(),
      },
    },
    '&.dpl-tag-warning': {
      backgroundColor: getBrandColor('warning0').hex(),
      borderColor: getBrandColor('warning0').hex(),
      '& *': {
        color: getBrandColor('warning1').hex(),
      },
    },
  },
  rateInfo: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1),
    '& .score': {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  statsInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    textAlign: 'center',
    marginBottom: theme.spacing(1),
    '& .label': {
      color: getBrandColor('coolGray6').hex(),
    },
  },
  infoRows: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing(1),
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    '& span': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
}))
